import React, {useCallback, useMemo} from 'react';
import {PasswordContainer} from '../../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../../components/Settings/SettingsPageContainer';
import {onClickHandler} from '../../../../../utils/onclick';
import './index.scss';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {GatewayCommand} from '../../../../../types/control';
import {useQuestion} from '../../../../../hooks/question';
import {useMessage} from '../../../../../hooks/message';
import {useRPC} from '../../../../../hooks/rpc';

export function GatewayControlScreen() {
    const {id} = useParams();
    const [rpc] = useRPC();
    const question = useQuestion();
    const {success} = useMessage();

    const gatewayList = useSelector(state => state.control.gatewayList);
    const selectedGateway = useMemo(() => gatewayList.find((g) => g.id === id), [gatewayList, id]);

    const onShutdownClick = useCallback(() => {
        question(`${selectedGateway.name} kapatılacaktır. Devam edilsin mi?`, () => {
            success('Kapatılıyor...');
            rpc.manageGateway(selectedGateway.id, GatewayCommand.Shutdown);
        });
    }, [
        question,
        rpc,
        selectedGateway.id,
        selectedGateway.name,
        success,
    ]);

    const onRestartClick = useCallback(() => {
        question(`${selectedGateway.name} yeniden başlatılacaktır. Devam edilsin mi?`, () => {
            success('Yeniden başlatılıyor...');
            rpc.manageGateway(selectedGateway.id, GatewayCommand.Reboot);
        });
    }, [
        rpc,
        question,
        selectedGateway,
        success,
    ]);

    const onSupervisorRestartClick = useCallback(() => {
        question(`${selectedGateway.name} supervisor yeniden başlatılacaktır. Devam edilsin mi?`, () => {
            success('Supervisor yeniden başlatılıyor...');
            rpc.manageGateway(selectedGateway.id, GatewayCommand.RestartSupervisor);
        });
    }, [
        question,
        rpc,
        selectedGateway.id,
        selectedGateway.name,
        success,
    ]);

    const onWorkerRestartClick = useCallback(() => {
        question(`${selectedGateway.name} worker yeniden başlatılacaktır. Devam edilsin mi?`, () => {
            success('Worker yeniden başlatılıyor...');
            rpc.manageGateway(selectedGateway.id, GatewayCommand.RestartWorker);
        });
    }, [
        question,
        rpc,
        selectedGateway.id,
        selectedGateway.name,
        success,
    ]);

    return (
        <PasswordContainer requiredRole='admin' isFullscreen={true}>
            <SettingsPageContainer
                className='service-edit'
                buttons={[]}
                backUrl={'/settings'}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        <div className='database-screen-container'>
                            <div className='button' {...onClickHandler(onShutdownClick)}>
                                <span className='text'>KAPAT</span>
                            </div>
                            <div className='button' {...onClickHandler(onRestartClick)}>
                                <span
                                    className='text'>YENİDEN BAŞLAT</span>
                            </div>
                            <div className='button' {...onClickHandler(onSupervisorRestartClick)}>
                                <span
                                    className='text'>SUPERVISORU YENİDEN BAŞLAT</span>
                            </div>
                            <div className='button' {...onClickHandler(onWorkerRestartClick)}>
                                <span
                                    className='text'>WORKERI YENİDEN BAŞLAT</span>
                            </div>
                        </div>
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
}
